import { SaveButton } from "components/Buttons"
import MapComponent from "components/GoogleMap"
import Table from "components/Table"
import { STATES } from "constants/states"
import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { Col, Input, Modal, Row } from "reactstrap"
import placesListColumns from "./placesListColumns"
import Select from "react-select"
import {
  deletePlace,
  getPlaces,
  hideBulkUploadModal,
  hideConfirmDeleteModal,
  openConfirmDeleteModal,
  showBulkUploadModal,
} from "store/actions"
import { Link, withRouter } from "react-router-dom"
import { URL_PATHS } from "constants/index"
import ModalComponent from "components/Modals"
import BulkUploadModal from "./bulkUploadModal"
import XLSX from "xlsx"
import * as url from "helpers/url_helper"
import { get } from "helpers/api_helper"
import { ActionsDropdown } from "components/Dropdowns"

const PlacesListTab = ({
  places,
  vendorId,
  getPlaces,
  selectedBusinesUnit,
  history,
  confirmDeleteModalIsOpen,
  openConfirmDeleteModal,
  hideConfirmDeleteModal,
  deletePlace,
  loading,
  bulkUploadModalIsOpen,
  showBulkUploadModal,
  hideBulkUploadModal,
}) => {
  const [searchValue, setSearchValue] = useState("")
  const [stateSearchValues, setStateSearchValue] = useState({
    value: null,
    label: "All States",
  })
  const [showResetButton, setShowResetButton] = useState(false)
  const [defaultOrder, setDefaultOrder] = useState({
    o: "name",
    od: "asc",
  })
  const [selectedPlace, setSelectedPlace] = useState()
  const CSVFile = useRef(null)
  const [bulkUploadPlaces, setBulkUploadPlaces] = useState([])

  useEffect(() => {
    getPlaces({
      ...defaultOrder,
      page: 1,
      per_page: 25,
      // vendor_id: vendorId,
      ...(selectedBusinesUnit?.value
        ? { business_unit_id: selectedBusinesUnit?.value }
        : {}),
      ...(searchValue.trim().length ? { search: searchValue } : {}),
      ...(stateSearchValues?.value ? { state: stateSearchValues?.value } : {}),
    })
  }, [selectedBusinesUnit])

  const actions = [
    {
      name: "Edit",
      onClick: item => {
        history.push(`/places/${item.id}`)
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Remove",
      onClick: item => {
        setSelectedPlace(item)
        openConfirmDeleteModal()
      },
      icon: "bx bx-trash",
      isAvailable: true,
    },
    {
      name: "View Surveys",
      onClick: item => {
        history.push(`/places/${item.id}/surveys`)
      },
      icon: "mdi mdi-eye-outline",
      isAvailable: true,
    },
  ]

  const onUploadCSV = () => {
    CSVFile.current.click()
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getPlaces({
      o: sortField,
      od: sortOrder,
      page: 1,
      per_page: 25,
      vendor_id: vendorId,
      ...(selectedBusinesUnit?.value
        ? { business_unit_id: selectedBusinesUnit?.value }
        : {}),
      ...(searchValue.trim().length ? { search: searchValue } : {}),
      ...(stateSearchValues?.value ? { state: stateSearchValues?.value } : {}),
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  const handleSearch = () => {
    if (searchValue.trim().length || stateSearchValues?.value) {
      getPlaces({
        o: "name",
        od: "asc",
        page: 1,
        per_page: 25,
        vendor_id: vendorId,
        ...(selectedBusinesUnit?.value
          ? { business_unit_id: selectedBusinesUnit?.value }
          : {}),
        ...(searchValue.trim().length ? { search: searchValue } : {}),
        ...(stateSearchValues?.value
          ? { state: stateSearchValues?.value }
          : {}),
      })
      setShowResetButton(true)
    }
    if (!searchValue.trim().length && !stateSearchValues?.value) {
      getPlaces({
        o: "name",
        od: "asc",
        page: 1,
        per_page: 25,
        vendor_id: vendorId,
        ...(selectedBusinesUnit?.value
          ? { business_unit_id: selectedBusinesUnit?.value }
          : {}),
      })
      setShowResetButton(false)
    }
  }

  const handleResetSearch = () => {
    getPlaces({
      o: "name",
      od: "asc",
      page: 1,
      per_page: 25,
      vendor_id: vendorId,
      ...(selectedBusinesUnit?.value
        ? { business_unit_id: selectedBusinesUnit?.value }
        : {}),
    })
    setSearchValue("")
    setStateSearchValue({
      value: null,
      label: "All States",
    })
    setShowResetButton(false)
  }

  const handlePageChange = page => {
    getPlaces({
      page: page,
      ...defaultOrder,
      per_page: 25,
      vendor_id: vendorId,
      ...(selectedBusinesUnit?.value
        ? { business_unit_id: selectedBusinesUnit?.value }
        : {}),
      ...(searchValue.trim().length ? { search: searchValue } : {}),
      ...(stateSearchValues?.value ? { state: stateSearchValues?.value } : {}),
    })
  }

  const handleDelete = () => {
    deletePlace({
      id: selectedPlace?.id,
      callback: () => {
        getPlaces({
          ...defaultOrder,
          page: places?.current_page || 1,
          per_page: 25,
          vendor_id: vendorId,
          ...(selectedBusinesUnit?.value
            ? { business_unit_id: selectedBusinesUnit?.value }
            : {}),
          ...(searchValue.trim().length ? { search: searchValue } : {}),
          ...(stateSearchValues?.value
            ? { state: stateSearchValues?.value }
            : {}),
        })
      },
    })
  }

  const handleCSVUpload = event => {
    const { files } = event.target
    if (files.length > 0) {
      const reader = new FileReader()
      reader.onload = ({ target: { result } }) => {
        const wb = XLSX.read(result, { type: "binary" })
        let places = []
        Object.keys(wb.Sheets).forEach(key => {
          const range = XLSX.utils.decode_range(wb.Sheets[key]["!ref"])
          const numOfRows = range.e.r - range.s.r + 1
          const sheet = XLSX.utils.sheet_to_json(wb.Sheets[key], {
            header: [
              "name",
              "details",
              "hours",
              "address_street_1",
              "address_street_2",
              "city",
              "state",
              "zip_code",
              "country_code",
              "lat",
              "lon",
              "category",
              "handicap_access",
              "starred",
            ],
            range: { s: { c: 0, r: 0 }, e: { c: 13, r: numOfRows } },
            defval: "",
          })
          places = [...places, ...sheet]
        })

        setBulkUploadPlaces(places)
        showBulkUploadModal()
        event.target.value = ""
        event.target.files = null
      }

      reader.readAsBinaryString(files[0])
    }
  }

  const downloadHandler = async () => {
    const response = await get(url.PLACES_URL, {
      params: {
        ...defaultOrder,
        page: 1,
        per_page: places?.total,
        vendor_id: vendorId,
        ...(selectedBusinesUnit?.value
          ? { business_unit_id: selectedBusinesUnit?.value }
          : {}),
        ...(searchValue.trim().length ? { search: searchValue } : {}),
        ...(stateSearchValues?.value
          ? { state: stateSearchValues?.value }
          : {}),
      },
    })

    const worksheet = XLSX.utils.json_to_sheet(
      response?.data.map(item => {
        return {
          Name: item?.name,
          Details: item?.details,
          Category: item?.category ? item?.category?.name : "",
          Hours: item?.hours,
          Latitude: item?.lat,
          Longitude: item?.lon,
          Address_Street_1: item?.address_street_1,
          Address_Street_2: item?.address_street_2,
          City: item?.city,
          State: item?.state,
          Zip_Code: item?.zip_code,
          Country_Code: item?.country_code,
          Handicap_Access: item?.handicap_access ? "true" : "false",
          Starred: item?.starred ? "true" : "false",
          Internal_Notes: item?.notes,
          Coupon: item?.coupon,
        }
      })
    )
    const csv = XLSX.utils.sheet_to_csv(worksheet, {
      strip: true,
      blankrows: true,
      skipHidden: true,
    })
    saveAs(
      new Blob([csv], { type: "text/plain;charset=utf-8" }),
      "Places List.csv"
    )
  }

  const menuActions = [
    {
      name: "Sample Import File",
      onClick: () => {
        window.open(
          "https://encappture.com/wp-content/uploads/2021/04/PlaceImportTemplate.csv"
        )
      },
      icon: "bx bx-file-blank",
      isAvailable: true,
    },
    {
      name: "Upload Bulk(.csv)",
      onClick: onUploadCSV,
      icon: "bx bx-upload",
      isAvailable: true,
    },
    {
      name: "Download",
      onClick: downloadHandler,
      icon: "bx bx-download",
      isAvailable: true,
    },
  ]

  return (
    <React.Fragment>
      <Row className="d-md-none my-1 d-flex justify-content-end">
        <Col xs="auto" style={{ minWidth: "fit-content" }} className="my-1">
          <ActionsDropdown
            label={"Menu"}
            icon={"mdi mdi-dots-vertical"}
            actionsList={menuActions}
            menuPosition={"start"}
            fullWidth={true}
          />
        </Col>
      </Row>
      <Row className="my-3 d-flex justify-content-end">
        <Col>
          <Row className="d-flex justify-content-center">
            <Col xs="auto" className="my-1">
              <Input
                placeholder="Name or Address"
                value={searchValue}
                onChange={event => {
                  setSearchValue(event.target.value)
                }}
              />
            </Col>
            <Col xs="auto" className="my-1">
              <div style={{ width: "150px" }}>
                <Select
                  value={stateSearchValues}
                  onChange={v => setStateSearchValue(v)}
                  options={[{ value: null, label: "All States" }, ...STATES]}
                />
              </div>
            </Col>
            <Col xs="auto" className="my-1">
              <SaveButton
                type="button"
                content="Search"
                onClick={handleSearch}
              />
            </Col>
            {showResetButton && (
              <Col xs="auto" className="my-1">
                <SaveButton
                  type="button"
                  content="Reset"
                  onClick={handleResetSearch}
                  color="light"
                />
              </Col>
            )}
          </Row>
        </Col>
        <Col
          xs={1}
          style={{ minWidth: "fit-content" }}
          className="my-1 d-none d-md-block"
        >
          <ActionsDropdown
            label={"Menu"}
            icon={"mdi mdi-dots-vertical"}
            actionsList={menuActions}
            menuPosition={"end"}
            fullWidth={true}
          />
        </Col>
      </Row>

      <Row className="my-3 mt-5" style={{ minHeight: "500px" }}>
        <Col xl={5} className="mt-3">
          {places?.total > 0 && (
            <p>
              Displaying {places?.data?.length} of {places?.total} Places
            </p>
          )}
          <MapComponent markers={places?.data} history={history} />
        </Col>
        <Col>
          <div className="d-flex justify-content-end my-2">
            <Link to={URL_PATHS.ADD_PLACE}>
              <SaveButton type="button" content="Add Place" />
            </Link>
          </div>
          <Table
            columns={placesListColumns()}
            data={places?.data}
            actions={actions}
            paginationData={{
              current_page: places?.current_page,
              last_page: places?.last_page,
              total_items: places?.total,
              items_per_page: places?.per_page,
              from: places?.from,
              to: places?.to,
              first_page: 1,
            }}
            onTableSort={handleSort}
            onPageChange={handlePageChange}
          />
        </Col>
      </Row>
      <ModalComponent
        open={confirmDeleteModalIsOpen}
        onClose={hideConfirmDeleteModal}
        title={`Delete place  - ${selectedPlace?.name}`}
      >
        <Row>
          <h5>Are you sure you want to delete this place?</h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={hideConfirmDeleteModal}
            />
          </Col>
          <Col>
            <SaveButton
              type="button"
              content="Delete"
              fullWidth={true}
              onClick={handleDelete}
              loading={loading}
            />
          </Col>
        </Row>
      </ModalComponent>
      <Modal
        style={{ maxWidth: "1600px" }}
        isOpen={bulkUploadModalIsOpen}
        toggle={() => {
          hideBulkUploadModal()
          setBulkUploadPlaces([])
        }}
        onClosed={() => {
          setBulkUploadPlaces([])
          getPlaces({
            ...defaultOrder,
            page: 1,
            per_page: 25,
            vendor_id: vendorId,
            ...(selectedBusinesUnit?.value
              ? { business_unit_id: selectedBusinesUnit?.value }
              : {}),
            ...(searchValue.trim().length ? { search: searchValue } : {}),
            ...(stateSearchValues?.value
              ? { state: stateSearchValues?.value }
              : {}),
          })
        }}
        size="xl"
        centered={true}
        scrollable={true}
      >
        <BulkUploadModal
          places={bulkUploadPlaces}
          selectedBusinesUnit={selectedBusinesUnit}
        />
      </Modal>
      <input
        ref={CSVFile}
        onChange={handleCSVUpload}
        type="file"
        accept=".csv"
        className="d-none"
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  places: state.PlacesList.places,
  vendorId: state.Login.vendorId,
  confirmDeleteModalIsOpen: state.PlacesList.confirmDeleteModalIsOpen,
  loading: state.PlacesList.loading,
  bulkUploadModalIsOpen: state.PlacesList.bulkUploadModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  getPlaces: values => dispatch(getPlaces(values)),
  openConfirmDeleteModal: () => dispatch(openConfirmDeleteModal()),
  hideConfirmDeleteModal: () => dispatch(hideConfirmDeleteModal()),
  deletePlace: values => dispatch(deletePlace(values)),
  showBulkUploadModal: () => dispatch(showBulkUploadModal()),
  hideBulkUploadModal: () => dispatch(hideBulkUploadModal()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PlacesListTab))
